import React from 'react';
// Corrected the import path here (removed the extra -router)
import { HashLink as Link } from 'react-router-hash-link';
import '../../styles/Footer.css'

function Index() { 
  return (
    <>
        <div className="footer">
            <div className="footer-wrap">
                <div className="footer-grid">
                    <div className="main-col left">
                        <div className="ftr-logo-m">
                            <img src="/vscimages/logo/VICTORIA SPORTS logo(1).png" alt="Victoria Sports Logo" />
                        </div>

                        <div className="news-col-sec">
                            <p>SUBSCRIBE TO OUR NEWSLETTER</p>
                            <form action="https://lascasasfilipinas.us1.list-manage.com/subscribe/post?u=2dc85a100274ce1d29cb7076c&amp;id=81f43e7f29" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="news-input validate" target="_blank" noValidate>
                                <input type="email" name="EMAIL" className="email" id="mce-EMAIL" placeholder="email address" required />
                                <div aria-hidden="true" className='hid'><input type="text" name="b_2dc85a100274ce1d29cb7076c_81f43e7f29" tabIndex="-1" value=""/></div>
                                <div className="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="button subscribe"/></div>
                            </form>
                        </div>
                    </div>

                    <div className="main-col right">
                        <div className="col-grid">
                            <div className="col-grid-right">
                                <h1>FOR INQUIRIES & BOOKINGS</h1>
                                <p>+63 927 559 7631 <br /> info@victoriasportsclub.com.ph </p>
                                <p>7F, Victoria Sports Tower 2, <br/>
                                    799 EDSA South Triangle Quezon City
                                </p>
                            </div>

                            <div className="col-grid-right">
                                <h1>RELATED LINKS</h1>
                                <Link smooth to="/#facilities-carousel" className='ftrLink' ><p>Facilities</p></Link>
                                <Link smooth to="/#home-news" className='ftrLink' ><p>Press</p></Link>
                                <Link smooth to="/#home-membership" className='ftrLink' ><p>Membership</p></Link>
                            </div> 

                            <div className="col-grid-right">
                                <h1> <i>more from</i> VICTORIA SPORTS CLUB </h1>
                                <a href="https://www.vshotel.com.ph/" target="_blank" rel="noreferrer" className='ftrLink' ><p>VS Hotel</p></a>
                                <a href="https://www.vshotel.com.ph/vskin" target="_blank" rel="noreferrer" className='ftrLink' ><p>VS Skin</p></a>
                                <a href="https://www.victoriasportsclub.com/cinema" target="_blank" rel="noreferrer" className='ftrLink' ><p>VS Cinema</p></a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="breaker"></div>

                <div className="footer-bottom-grid">
    
                    <div className="socs-col-img">
                        <a href="https://www.facebook.com/thevictoriasportsclub" target="_blank" rel="noreferrer">
                            <img src="/vscimages/socialmed/Vector.png" alt="facebook icon" />
                        </a>

                        <a href="https://www.instagram.com/thevictoriasportsclub/" target="_blank" rel="noreferrer">
                            <img src="/vscimages/socialmed/Vectorig.png" alt="instagram icon" />
                        </a>
                    </div>

                    <div className="footer-bottom-links">
                        <p>Copyright © 2026 Victoria Sports Club</p>

                        <div className="legal-links">
                            <Link to="/privacy-policy" className="legal-link">
                                Privacy Policy
                            </Link>

                            <span>•</span>

                            <Link to="/terms-and-conditions" className="legal-link">
                                Terms & Conditions
                            </Link>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </>
  )
}

export default Index;



// import React from 'react';
// import { Link } from 'react-router-dom';
// import '../../styles/Footer.css'

// function index() {
//   return (
//     <>
//         <div className="footer">
//             <div className="footer-wrap">
//                 <div className="footer-grid">
//                     <div className="main-col left">
//                         <div className="ftr-logo-m">
//                             <img src="/vscimages/logo/VICTORIA SPORTS logo(1).png" alt="" />
//                         </div>

//                         <div className="news-col-sec">
//                             <p>SUBSCRIBE TO OUR NEWSLETTER</p>
//                             <form action="https://lascasasfilipinas.us1.list-manage.com/subscribe/post?u=2dc85a100274ce1d29cb7076c&amp;id=81f43e7f29" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate="" className="news-input">
//                                 <input type="email" name="EMAIL" class="email" id="mce-EMAIL" placeholder="email address" required />
//                                 <div aria-hidden="true" className='hid'><input type="text" name="b_2dc85a100274ce1d29cb7076c_81f43e7f29" tabindex="-1" value=""/></div>
//                                 <div class="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button" className='subscribe'/></div>
//                             </form>
//                         </div>
//                     </div>

//                     <div className="main-col right">
//                         <div className="col-grid">
//                             <div className="col-grid-right">
//                                 <h1>FOR INQUIRIES & BOOKINGS</h1>
//                                 <p>+63 927 559 7631 <br /> info@victoriasportsclub.com.ph </p>

//                                 <p>7F, Victoria Sports Tower 2, <br/>
//                                     799 EDSA South  Triangle Quezon City
//                                 </p>
//                             </div>

//                             <div className="col-grid-right">
//                                 <h1>RELATED LINKS</h1>
//                                 <Link to="/facilities" className='ftrLink' ><p>Facilities</p></Link>
//                                 <Link to="/offers" className='ftrLink' ><p>Special Offers</p></Link>
//                                 <Link to="/membership" className='ftrLink' ><p>Membership</p></Link>
//                                 <Link to="/events" className='ftrLink' ><p>Events</p></Link>
//                                 <Link to="/contact" className='ftrLink' ><p>About Us</p></Link>
//                                 <Link to="/inquiry" className='ftrLink' ><p>Inquiry</p></Link>
//                                 <Link to="/cinema" className='ftrLink' ><p>Cinema</p></Link>
//                                 {/* <Link to="/book" className='ftrLink' ><p>Book Now</p></Link> */}
//                             </div> 

//                             <div className="col-grid-right">
//                                 <h1> <i>more from</i> VICTORIA SPORTS CLUB </h1>
//                                 <Link to="https://www.vshotel.com.ph/" target="_blank" className='ftrLink' ><p>VS Hotel</p></Link>
//                                 {/* <Link to="https://www.lascasasfilipinas.com/" target="_blank" className='ftrLink' ><p>Las Casas Filipinas De Acuzar - Bagac Bataan</p></Link>
//                                 <Link to="https://lascasasqc.com/" target="_blank" className='ftrLink' ><p>Las Casas Quezon City</p></Link>
//                                 <Link to="https://lascasasweddings.com/" target="_blank" className='ftrLink' ><p>Las Casas Weddings</p></Link> */}
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="breaker">

//                 </div>

//                 <div className="footer-bottom-grid">
//                     <div className="socs-col-img">
//                         <Link to="https://www.facebook.com/thevictoriasportsclub" target="_blank"><img src="/vscimages/socialmed/Vector.png" alt="facebook icon" /></Link>
//                         <Link to="https://www.instagram.com/thevictoriasportsclub/" target="_blank"><img src="/vscimages/socialmed/Vectorig.png" alt="instagram icon" /></Link>
//                     </div>

//                     <p>Copyright © 2024 Victoria Sports Club</p>
//                 </div>
//             </div>
//         </div>
//     </>
//   )
// }

// export default index